import { isVetPetsPreviewHost } from "./request-origin"

const UI_COOKIE_NAME = "vetpets_staged_preview_ui"

const normalized = (value?: string | null) => value?.trim().replace(/\/$/, "") || ""

function hasPreviewUiMarker(cookieString: string) {
  return cookieString
    .split(";")
    .map((part) => part.trim())
    .some((part) => part === `${UI_COOKIE_NAME}=1`)
}

export function resolveStagedPreviewBackendUrl(
  publicUrl?: string | null,
  cookieString?: string,
  browserOrigin?: string
) {
  const fallback = normalized(publicUrl)
  const cookies = cookieString ?? (typeof document !== "undefined" ? document.cookie : "")
  const origin = normalized(
    browserOrigin ?? (typeof window !== "undefined" ? window.location.origin : "")
  )

  if (origin) {
    try {
      const parsed = new URL(origin)
      if (parsed.protocol === "https:" && !parsed.port && isVetPetsPreviewHost(parsed.hostname)) {
        return `${parsed.origin}/__vetpets-medusa`
      }
    } catch {
      // Keep the configured public backend for malformed browser origins.
    }
  }

  if (origin && hasPreviewUiMarker(cookies)) {
    return `${origin}/__vetpets-medusa`
  }
  return fallback
}

const PREVIEW_HOST_RE = /^[0-9a-f]{12}\.preview\.vetpets\.com\.tr$/
const GARANTI_TEST_FORM_ACTION = "https://sanalposprovtest.garantibbva.com.tr/servlet/gt3dengine"

function isSafePreviewTestPaymentSession(session: unknown, previewHost?: string | null) {
  if (!previewHost || !PREVIEW_HOST_RE.test(previewHost)) return false
  if (!session || typeof session !== "object" || Array.isArray(session)) return false
  const record = session as Record<string, unknown>
  if (record.provider_id !== "pp_garanti_garanti") return false
  const data = record.data
  if (!data || typeof data !== "object" || Array.isArray(data)) return false
  const payment = data as Record<string, unknown>
  const callback = `https://${previewHost}/hooks/garanti/3d-return`
  return payment.mode === "TEST" &&
    payment.garanti_profile_mode === "TEST" &&
    payment.form_action === GARANTI_TEST_FORM_ACTION &&
    payment.successurl === callback &&
    payment.errorurl === callback
}

export function sanitizeIsolatedPreviewCart<T>(cart: T, isolated: boolean, previewHost?: string | null): T {
  if (!isolated || !cart || typeof cart !== "object") return cart
  const record = cart as Record<string, unknown>
  const paymentCollection = record.payment_collection
  if (!paymentCollection || typeof paymentCollection !== "object" || Array.isArray(paymentCollection)) return cart
  const paymentRecord = paymentCollection as Record<string, unknown>
  if (!Array.isArray(paymentRecord.payment_sessions)) return cart
  return {
    ...record,
    payment_collection: {
      ...paymentRecord,
      payment_sessions: paymentRecord.payment_sessions.filter((session) =>
        isSafePreviewTestPaymentSession(session, previewHost)
      ),
    },
  } as T
}
